import { Box, Button, Dialog, DialogContent, DialogTitle, List, ListItemText } from '@mui/material';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';

function HistoryDetails({ selectedParticipant, isOpen, closeModal }: any) {
  const { t } = useTranslation();

  const StyledListItemText = styled(ListItemText)({
    '& .MuiTypography-root': {
      fontSize: 12,
    }
  });

  return (
    <Dialog maxWidth={false} open={isOpen} onClose={() => closeModal()}>
      <Box>
        <DialogTitle>{selectedParticipant.displayName}</DialogTitle>
        <DialogContent>
          <List>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.protocol')}:&nbsp;</strong>
              {selectedParticipant.protocol}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.isPresenting')}:&nbsp;</strong>
              {selectedParticipant.isPresenting
                ? <span className="is-true">{t('HistoryDetails.details.yes')}</span>
                : <span className="is-false">{t('HistoryDetails.details.no')}</span>}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.connectTime')}:&nbsp;</strong>
              {selectedParticipant.connectTime}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.serviceTag')}:&nbsp;</strong>
              {selectedParticipant.serviceTag}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.callTag')}:&nbsp;</strong>
              {selectedParticipant.callTag}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.mediaNode')}:&nbsp;</strong>
              {selectedParticipant.mediaNode}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.uuid')}:&nbsp;</strong>
              {selectedParticipant.uuid}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.callId')}:&nbsp;</strong>
              {selectedParticipant.callId}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.vendor')}:&nbsp;</strong>
              {selectedParticipant.vendor}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.role')}:&nbsp;</strong>
              {selectedParticipant.role}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.conversationId')}:&nbsp;</strong>
              {selectedParticipant.conversationId}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.destinationAlias')}:&nbsp;</strong>
              {selectedParticipant.destinationAlias}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.isStreaming')}:&nbsp;</strong>
              {selectedParticipant.isStreaming
                ? <span className="is-true">{t('HistoryDetails.details.yes')}</span>
                : <span className="is-false">{t('HistoryDetails.details.no')}</span>}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.isMuted')}:&nbsp;</strong>
              {selectedParticipant.isMuted
                ? <span className="is-true">{t('HistoryDetails.details.yes')}</span>
                : <span className="is-false">{t('HistoryDetails.details.no')}</span>}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.remoteAddress')}:&nbsp;</strong>
              {selectedParticipant.remoteAddress}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.systemOs')}:&nbsp;</strong>
              {selectedParticipant.deviceOsName}
              {' '}
              {selectedParticipant.deviceOsVersion}
              {' '}
              {selectedParticipant.deviceOsPlatform}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.device')}:&nbsp;</strong>
              {selectedParticipant.deviceType}
              {' '}
              {selectedParticipant.deviceBrand}
              {' '}
              {selectedParticipant.deviceModel}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.client')}:&nbsp;</strong>
              {selectedParticipant.clientType}
              {' '}
              {selectedParticipant.clientName}
              {' '}
              {selectedParticipant.clientVersion}
            </StyledListItemText>
            <StyledListItemText>
              <strong>{t('HistoryDetails.details.callQuality')}:&nbsp;</strong>
              {selectedParticipant.callQualityNow}
            </StyledListItemText>
          </List>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => closeModal()}
          >
            {t('HistoryDetails.button.back')}
          </Button>
        </DialogContent>
      </Box>
    </Dialog>
  );
}

export default HistoryDetails;
